import { c as _c } from "react/compiler-runtime";
import { SvgIcon, SvgIconProps } from '@mui/material';
const CCIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M8 0.146c-0.068 0-0.132-0.002-0.199 0-4.242 0.108-7.655 3.586-7.655 7.854 0 4.336 3.519 7.854 7.854 7.854s7.854-3.519 7.854-7.854-3.519-7.854-7.854-7.854zM8 14.505c-3.59 0-6.504-2.914-6.504-6.504 0-3.52 2.804-6.394 6.297-6.504 0.070-0.002 0.137 0 0.207 0 3.59 0 6.504 2.914 6.504 6.504s-2.914 6.504-6.504 6.504zM5.331 6.248c0.675 0.015 0.929 0.339 1.026 0.829l1.205 0.004c-0.195-1.128-1.023-1.792-2.201-1.798-1.333-0.006-2.3 1.106-2.304 2.479-0.005 1.466 0.955 2.489 2.289 2.493 0.040 0 0.078 0.002 0.117 0 0.009-0 0.018 0 0.027 0 0.833-0.011 1.966-0.592 1.97-1.727l-1.076-0.003c-0.072 0.491-0.504 0.805-1.003 0.764-0.020-0.001-0.039-0-0.059-0-0.812-0.002-1.131-0.618-1.155-1.524-0.025-0.946 0.525-1.532 1.164-1.517zM10.903 9.289c-0.020-0.001-0.039-0-0.059-0-0.812-0.002-1.131-0.618-1.155-1.524-0.025-0.946 0.525-1.532 1.164-1.517 0.675 0.015 0.929 0.339 1.026 0.829l1.205 0.004c-0.195-1.128-1.023-1.792-2.201-1.798-1.333-0.006-2.3 1.106-2.304 2.479-0.005 1.466 0.955 2.489 2.289 2.493 0.040 0 0.078 0.002 0.117 0 0.009-0 0.018 0 0.027 0 0.833-0.011 1.966-0.592 1.97-1.727l-1.076-0.003c-0.072 0.491-0.505 0.805-1.003 0.764z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon viewBox="0 0 16 16" {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default CCIcon;